import { Landing } from "components";

const LandingPage = () => {
  return <Landing />;
};

export default LandingPage;
